// The tenant is resolved by the proxy and server-rendered onto the document, so this never
// imports the tenant registry - a client import of it ships every tenant's config to every
// visitor. Reading the DOM also means no provider has to be mounted first: the callers below
// include plain modules that run outside React.
export function isWebsiteBrowser(tenant?: string): boolean {
  if (typeof document === 'undefined') return false;
  const resolved = document.documentElement.dataset.websiteTenant;
  return Boolean(resolved && (!tenant || resolved === tenant));
}

export function chatApiBaseUrl(tenant: string): string {
  return isWebsiteBrowser(tenant)
    ? '/api/website'
    : (process.env.NEXT_PUBLIC_CHAT_API_BASE_URL ?? '');
}
